import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { FieldError, Merge } from 'react-hook-form';

import CheckboxListItem, { CheckboxListItemProps } from '@components/atoms/checkboxListItem';

export const StyleCheckboxListItem = styled(CheckboxListItem)<
  CheckboxListItemProps & {
    isError?: boolean;
    isAnswer?: boolean;
    isCorrect?: boolean;
    isSubmitted?: boolean;
    isLoading?: boolean;
    isShowHint?: boolean;
    isContaionIncorrectAnswer: Merge<FieldError, (FieldError | undefined)[]> | undefined;
      }
      >(({ theme, checked, isError, isAnswer, isCorrect, isSubmitted, isLoading, isShowHint, isContaionIncorrectAnswer }) => {
        let borderColor = 'rgba(0, 0, 0, 0.38)';
        let backgroundColor = 'transparent';

        if (!isSubmitted) {
          // default
          borderColor = 'rgba(0, 0, 0, 0.38)';
          backgroundColor = 'transparent';
          if (checked && (!isSubmitted || isLoading)) {
            borderColor = theme.palette.primary.main;
            backgroundColor = alpha(theme.palette.primary.main, 0.12);
          }
        } else if (isContaionIncorrectAnswer) {
          if (isError) {
            // still have wrong answer
            borderColor = isShowHint ? '#F44336' : 'rgba(0, 0, 0, 0.38)';
            backgroundColor = isShowHint ? 'rgba(244, 67, 54, 0.2)' : '#EEEEEE';
          } else if (checked && (!isSubmitted || isLoading)) {
            // default
            borderColor = theme.palette.primary.main;
            backgroundColor = alpha(theme.palette.primary.main, 0.12);
          } else if ((checked && isCorrect) || isAnswer) {
            // correct answer
            backgroundColor = isShowHint ? theme.palette.backgroundSuccess?.primary || '' : '#EEEEEE';
          }
        } else if (!isContaionIncorrectAnswer) {
          if (isError) {
            // still have wrong answer
            borderColor = '#F44336';
            backgroundColor = 'rgba(244, 67, 54, 0.2)';
          } else if (checked && (!isSubmitted || isLoading)) {
            // default
            borderColor = theme.palette.primary.main;
            backgroundColor = alpha(theme.palette.primary.main, 0.12);
          } else if ((checked && isCorrect) || isAnswer) {
            // correct answer
            borderColor = theme.palette.borderSuccess?.primary || '';
            backgroundColor = theme.palette.backgroundSuccess?.primary || '';
          }
        }

        return `
    border-radius: 4px;
    border: 1px solid ${borderColor};
    margin-bottom: 16px;
    background-color: ${backgroundColor};

    &:last-of-type {
      margin-bottom: 0;
    }

    .MuiListItemButton-root {
      min-height: 65px;
    }
  `;
      });
